import React from 'react';
import { createStyles } from "./styles";








var ToolsDropdownOption = function ToolsDropdownOption(_ref)




{var href = _ref.href,linkText = _ref.linkText,icon = _ref.icon,customMainColor = _ref.customMainColor;
  var classes = createStyles({ customMainColor: customMainColor });

  return /*#__PURE__*/(
    React.createElement("li", { className: classes.toolDropdownOption }, /*#__PURE__*/
    React.createElement("a", { href: href, className: classes.toolDropdownLink }, /*#__PURE__*/
    React.createElement("span", { className: classes.toolDropdownIcon }, icon), /*#__PURE__*/
    React.createElement("span", { className: classes.toolDropdownLinkText }, linkText))));



};

export default ToolsDropdownOption;
//# sourceMappingURL=index.js.map